/**
 * @fileoverview added by tsickle
 * Generated from: serializers/time-slot.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { toDate } from '../util/datetime/index';
import { dateField, dateTimeField, modelSerializer, timeField } from '../util/serializers';
import { timeSlot } from '../models/time-slot';
/** @type {?} */
export var timeSlotSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: timeSlot,
    fields: {
        start: timeField.create(),
        end: timeField.create(),
        // Client-side fields
        day: dateField.create(),
        start_dt: dateTimeField.create({ optional: true }),
        end_dt: dateTimeField.create({ optional: true })
    },
    /**
     * Quirk of the slot model: internally slots are not related to days,
     * but it makes sense for them to be client side, so allow the day of
     * the slot to be determined by a property on the parent.
     * @param obj Object  - The partially deserialized slot.
     * @param kwargs Object  - Keyword arguments passed to the serializer
     * @return Object - A new slot instance.
     */
    preCreate: /**
     * Quirk of the slot model: internally slots are not related to days,
     * but it makes sense for them to be client side, so allow the day of
     * the slot to be determined by a property on the parent.
     * @param {?} obj Object  - The partially deserialized slot.
     * @param {?} kwargs Object  - Keyword arguments passed to the serializer
     * @return {?} Object - A new slot instance.
     */
    function (obj, kwargs) {
        if (kwargs.dayFrom) {
            /** @type {?} */
            var day = kwargs.parent[kwargs.dayFrom];
            if (day) {
                obj.day = toDate(day);
            }
        }
        return obj;
    }
})))));
